import { Component, lazy, Suspense } from 'react';
import AdditionalOptionsPicker from './AdditionalOptions';
import './Form.css';
import PlatePicker from './PlatePicker';
import TemplatePicker from './TemplatePicker';
import { TemplateSchedule } from './TemplateSchedule';
import WeightsPicker from './WeightsPicker';
const SchedulePicker = lazy(() => import("./SchedulePicker"));
const OutputOptions = lazy(() => import('./OutputOptions'));


class FiveThreeOneForm extends Component {
  formChanged = (formUpdate) => {
    const copy = { ...this.props.formData };
    this.props.onFormChanged?.(Object.assign(copy, formUpdate));
  }

  unitChanged = (newValue) => {
    this.formChanged({ unit: newValue });
  }

  trainingMaxesChanged = (newMaxes => {
    this.formChanged({ trainingMaxes: newMaxes });
  })

  scheduleChanged = (newSchedule) => {
    this.formChanged({ schedule: newSchedule });
  }

  platingChanged = (newPlating) => {
    this.formChanged({ plating: newPlating, });
  }

  additionalOptionsChanged = (newOptions) => {
    this.formChanged({ additionalOptions: newOptions });
  }

  templateChanged = (newTemplate) => {
    let newSchedule;
    let otherOrder;
    if (TemplateSchedule.for(newTemplate) !== TemplateSchedule.for(this.formData.template)) {
      const scheduleCopy = { ...this.formData.schedule };
      newSchedule = Object.assign(scheduleCopy, {
        liftsOrder: TemplateSchedule.for(newTemplate).daysOrder.slice(),
        daysAWeek: TemplateSchedule.for(newTemplate).allowedDaysPerWeek[TemplateSchedule.for(newTemplate).allowedDaysPerWeek.length - 1]
      });
    }
    const stateToSet = { template: newTemplate };

    if (newSchedule != null) {
      stateToSet.schedule = newSchedule;
    }
    if (otherOrder != null) {
      stateToSet.otherLiftsOrder = otherOrder;
    }
    this.formChanged(stateToSet);
  }

  get formData() {
    return this.props.formData;
  }

  outputOptionsChanged = (newOptions) => {
    this.formChanged({ output: newOptions });
  }

  render() {
    return <form>
      <WeightsPicker unit={this.formData.unit} unitChanged={this.unitChanged} trainingMaxesChanged={this.trainingMaxesChanged} trainingMaxes={this.formData.trainingMaxes} plateCalculator={this.props.plateCalculator}></WeightsPicker>
      <TemplatePicker unit={this.formData.unit} template={this.formData.template} templateChanged={this.templateChanged} plateCalculator={this.props.plateCalculator} additionalOptions={this.formData.additionalOptions}></TemplatePicker>
      <AdditionalOptionsPicker unit={this.formData.unit} options={this.formData.additionalOptions} optionsChanged={this.additionalOptionsChanged}></AdditionalOptionsPicker>

      <PlatePicker unit={this.formData.unit} plating={this.formData.plating} platingChanged={this.platingChanged}></PlatePicker>

      <Suspense fallback={<div style={{ height: 260 + 'px' }}></div>}>
        <SchedulePicker schedule={this.formData.schedule} scheduleChanged={this.scheduleChanged} template={this.formData.template}></SchedulePicker>
      </Suspense>
      <Suspense fallback={<div style={{ height: 260 + 'px' }}></div>}>
        <OutputOptions options={this.formData.output} optionsChanged={this.outputOptionsChanged}></OutputOptions>
      </Suspense>
    </form>;
  }
}

export default FiveThreeOneForm;